// Libraries
import React, { useEffect } from 'react';
import {Row, Col, Form, Modal, DatePicker} from 'antd';
import {useAppDispatch} from '../../store/store';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import { useTranslation } from 'react-i18next';

// Store
import { update } from '../../store/redux/actions/catalogActions';

// Types
import {AllianceStockType} from "../../types/AllianceStockTypes";

// Components
import ButtonComponent from '../subComponents/ButtonComponent';
import FormItemComponent from '../subComponents/FormItemComponent';
import InputComponent from '../subComponents/InputComponent';


type StockFormModalType = {
  supermodel: string;
  stockToEdit?: AllianceStockType;
  params?: URLSearchParams;
  onToggleModal: (visible: boolean) => void;
};
const StockFormModal = (props: StockFormModalType) => {
  const { t } = useTranslation();
  dayjs.extend(utc);
  const { RangePicker } = DatePicker;
  const { onToggleModal, stockToEdit, supermodel, params } = props;
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  useEffect(() => {
    let promotionDates = [];
    if(stockToEdit) {
        promotionDates[0] = 
          stockToEdit.promotionStartDate ? dayjs.utc(stockToEdit.promotionStartDate) : null;

        promotionDates[1] = 
          stockToEdit.promotionEndDate ? dayjs.utc(stockToEdit.promotionEndDate) : null;
      
      form.setFieldsValue({
        promotionDates: promotionDates
      });
    }
  }, []);

  const handleSubmit = (stock: AllianceStockType) => {
    stock.catalogId = stockToEdit!.catalogId;
    stock.baseStock = parseInt(stock.baseStock.toString());

    if (stock.promotionDates) {
      stock.promotionStartDate = stock.promotionDates[0];
      stock.promotionEndDate = stock.promotionDates[1];
    }
  
    dispatch(update(stock, supermodel, params));
    onToggleModal(false);
  }

  return (
    <Modal title={`${'edit'} stock`} open={true} maskClosable closable={false} keyboard={false} destroyOnHidden={true}
           footer={[
             <ButtonComponent key={'cancel'} text={t('close')}
                              className={'w-32 h-8 bg-white border border-grey-dkt-300 leading-4 text-grey-dkt-700 ' +
                                'hover:bg-grey-dkt-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-dkt-400'}
                              onClick={() => onToggleModal(false)} />,
             <ButtonComponent key={'submit'} text={t('edit')}
                              className={'w-32 h-8 bg-blue-dkt-400 text-white hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
                                'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'}
                              onClick = {() => form.submit()}/>,
           ]}>
      <Form layout={"vertical"} className={'pt-4'}
            form={form} onFinish={handleSubmit} initialValues={stockToEdit}>
        <Row gutter={[12, 0]}>
          <Col md={24} xs={24}>
            <FormItemComponent name={'name'} label={t('name')} required={false}
                               child={<InputComponent placeHolder={t('allianceExample')}
                                                      disabled={true}
                                                      readOnly={true} />}
            />
          </Col>
          <Col md={12} xs={24}>
            <FormItemComponent name={'baseStock'}
                               label={t('baseStock')}
                               required={true}
                               child={<InputComponent type={'number'} />}
            />
          </Col>
          <Col md={12} xs={24}>
            <FormItemComponent name={'price'}
                               label={t('discountPrice')}
                               required={true}
                               child={<InputComponent type={'currency'} prefix={t('currencySymbol')} />}
            />
          </Col>
          <Col md={24} xs={24}>
            <FormItemComponent name={'promotionDates'}
                               label={t('promotionDates')}
                               required={false}
                               child={<RangePicker showTime allowEmpty={[true, true]}/>}
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default StockFormModal;